import React, { useContext } from 'react';
import { UserContext } from '../../Context/UserContext';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Button from '../SelectValue/Button';
import success from '../../Assets/images/success2.png';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: 400,
  bgcolor: 'white',
  boxShadow: 24,
  outline: 'none',
  borderRadius: '8px',
  p: 3,
};

export default function SuccessModal({ open, handleClose, handleViewTransaction, unit, details, type }) {
  const { userDetails } = useContext(UserContext);
  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <Box sx={modalStyle}>
          <div className="flex flex-col items-center pt-2 pb-4">
            <img src={success} alt="success" className="w-20 h-20" />
            <h2 className="mt-4 text-[22px] font-[600] text-[#1E222B]">
              Purchase successful !
            </h2>
            <p className="mt-3 text-center text-[15px] text-[#808285] leading-relaxed">
              You have successfully purchased {unit} unit{unit > 1 ? "s" : ""} of {details?.title || type} {details?.locality ? `in ${details.locality}` : ""}
            </p>
            <div className="mt-6 p-4 bg-[#F5FCF8] rounded-lg flex gap-3 items-start w-full">
              <InfoOutlinedIcon sx={{ color: "#00BC67", mt: 0.2 }} fontSize="small" />
              <p className="text-[#00BC67] text-[13px] font-[700] leading-relaxed">
                Your transaction has been logged and a signed certificate of ownership has been generated and sent to {userDetails?.emailAddress || ''}.
              </p>
            </div>
            <div className="mt-8 w-full flex flex-col gap-3">
              <Button name="Done" onClick={handleClose} bool={true} />
              <button
                onClick={handleViewTransaction}
                className="w-full py-3 rounded-lg bg-[#FAFBFC] border border-[#E6E6E7] text-[#00BC67] font-[600] text-[15px]"
              >
                View transaction
              </button>
            </div>
          </div>
        </Box>
      </Fade>
    </Modal>
  );
}
